import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useTranslation();
  return (
    <main className="min-h-[70vh] flex items-center justify-center px-6 relative z-10" data-testid="payment-cancel-page">
      <div className="text-center max-w-md">
        <XCircle size={48} strokeWidth={1.2} className="text-muted-foreground mx-auto" />
        <h1 className="font-serif-display text-4xl mt-6">{t("payment.cancel")}</h1>
        <p className="text-foreground/65 mt-3">{t("payment.cancelDesc")}</p>
        <Link to="/parcours" className="inline-block mt-8 px-7 py-3 rounded-full border border-primary/40 text-primary text-sm hover:bg-primary/10 transition-colors duration-200" data-testid="cancel-back-btn">
          {t("payment.back")}
        </Link>
      </div>
    </main>
  );
}
